export default "__VITE_ASSET__CGoT9kg7__"